<template lang="pug">
form.section.content.has-text-centered(v-on:submit.prevent="submit")
  .columns
    .column
    .column
      .field
        div.is-size-3 Log In
      .field
        .control.is-expanded
          input.input(autocomplete="email" placeholder="Your email" ref="focus" type="email" v-bind:class="[$v.email.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.email.$model")
        .help.is-danger(v-show="$v.email.$error && !$v.email.email") Your email is invalid.
        .help.is-danger(v-show="$v.email.$error && !$v.email.required") Your email is required.
      .field
        .control.is-expanded
          input.input(autocomplete="current-password" placeholder="Your password" type="password" v-bind:class="[$v.password.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.password.$model")
        .help.is-danger(v-show="$v.password.$error && !$v.password.minLength") Your password is too short.
        .help.is-danger(v-show="$v.password.$error && !$v.password.required") Your password is required.
      .field.margin-top-40
        .control
          .buttons.is-centered
            button.button.is-primary(type="submit" v-bind:disabled="$v.$invalid") Log In
      .field.margin-top-40
        div Don't have an account? #[router-link(to="/sign-up") Create account]
        div #[router-link(to="/reset-password") Forgot your password?]
    .column
</template>

<script>
import { email, minLength, required } from 'vuelidate/lib/validators'

import ApiMixin from '@/mixins/ApiMixin.vue'
import DeviceMixin from '@/mixins/DeviceMixin.vue'

export default {
  mixins: [
    ApiMixin,
    DeviceMixin
  ],
  data () {
    return {
      email: null,
      password: null
    }
  },
  mounted () {
    this.deviceSetFocus()
  },
  methods: {
    submit () {
      this.apiLogIn(this.email, this.password)
    }
  },
  validations () {
    return {
      email: {
        email,
        required
      },
      password: {
        minLength: minLength(8),
        required
      }
    }
  }
}
</script>
